import "./Switch.css";
import React from "react";

import Schedule from "../visual/Schedule.js";

import { useDownloadCourseScheduleQuery } from "../../js/queryHooks.js";
import { CircularProgress, Checkbox } from "@mui/material";
import { useSearchParams } from "react-router-dom";

const schedDefault = {
  schedCategory: "",
  slots: [],
};

const filterSchedule = (schedule, { sessionType, staffNames }) => {
  if (!schedule) return schedule;
  const rawSessions = schedule.slots;
  const typeSessions = rawSessions.filter(
    (s) => !sessionType || s.type === sessionType
    // (!staffNames ||
    //   staffNames.every((name) => s.staff.some((staff) => staff.name === name)))
  );
  const staffSessions = typeSessions.map((s) => ({
    ...s,
    sessions: s.sessions.filter(
      (session) =>
        !staffNames ||
        staffNames.every((name) =>
          session.staff.some((staff) => staff.name === name)
        )
    ),
  }));
  console.log({ staffNames, typeSessions });

  const sessions = staffSessions.filter((s) => s.sessions.length > 0);

  return { ...schedule, slots: sessions };
};

const SimilarSessions = () => {
  const [searchParams, _setSearchParams] = useSearchParams();
  const courseCode = searchParams.get("courseCode");
  const sessionType = searchParams.get("sessionType");
  const staffNames = searchParams.get("staffNames")?.split(",");
  const [sameStaffOnly, setSameStaffOnly] = React.useState(true);

  const courseScheduleQuery = useDownloadCourseScheduleQuery(courseCode);
  const rawSchedule = courseScheduleQuery.data?.scheduleData;

  const schedule = filterSchedule(rawSchedule, { sessionType, staffNames: sameStaffOnly ? staffNames : null });

  return (
    <div className="container" style={{ margin: "10px" }}>
      <div id="title">Similar Sessions</div>

      <div>
        <Checkbox
          checked={sameStaffOnly}
          onChange={(e) => setSameStaffOnly(e.target.checked)}
        />
        <label style={{color:"var(--text-color)"}}>Same Staff Only</label>
      </div>
      {courseScheduleQuery.isLoading && <CircularProgress />}
      {courseScheduleQuery.error && (
        <div style={{ color: "var(--text-color)" }}>Error: {courseScheduleQuery.error}</div>
      )}
      {schedule && <Schedule schedule={schedule} />}
    </div>
  );
};

export default SimilarSessions;
